<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .cv-section {
    display: flex;
    align-items: center;
    gap: utils.in_rem(8px);

    .cv-info {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: utils.in_rem(8px);

      .destructive {
        @include colors.color(systemError_100);
      }
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import { showToast } from "@sourcewhale/core";
  import { saveCandidate } from "@sourcewhale/api";
  import { getDownloadUrl } from "../../../../api/files";
  import {
    activePopUpModalStore,
    candidateApiStore,
    candidateStore,
  } from "../stores";

  $: resumeFileId = $candidateStore.resumeFileId;

  const { meta } = candidateApiStore;
  $: isLoading = $meta.fetching;

  let closeDropdown;

  const showCV = async () => {
    if (!resumeFileId) return;

    try {
      const { url } = await getDownloadUrl(resumeFileId);
      window.open(url, "_blank");
    } catch {
      showToast({
        title: "Error",
        subtitle: "Failed to show Resume",
        type: "danger",
      });
    }
  };

  const openUploadModal = () => {
    activePopUpModalStore.set({
      modal: "uploadCV",
      candidateId: $candidateStore.candidateId,
    });
  };

  const removeCV = async () => {
    if (!$candidateStore.candidateId) return;

    try {
      // With falsy resumeFileId value, the field will be removed from the candidate ddb item
      await saveCandidate({
        candidateId: $candidateStore.candidateId,
        resumeFileId: null,
      });

      // hard refresh - deleting ddb field is not broadcast
      candidateApiStore.get();

      showToast({
        title: "Success",
        subtitle: "Resume removed",
        type: "success",
      });
    } catch {
      showToast({
        title: "Error",
        subtitle: "Failed to remove Resume",
        type: "danger",
      });
    }
  };
</script>

{#if !isLoading}
  <div class="cv-section">
    {#if resumeFileId}
      <div class="cv-info">
        <Dropdown
          kind="tertiary"
          size="xsmall"
          bind:close={closeDropdown}
          placement="bottom-end"
          dynamicWidth={false}
        >
          <span slot="button">Resume Actions</span>

          <ListItem
            icon="fa-regular fa-eye"
            onclick={() => {
              showCV();
              closeDropdown();
            }}
          >
            Show Resume
          </ListItem>

          <ListItem
            icon="fa-regular fa-arrow-up-from-bracket"
            onclick={() => {
              openUploadModal();
              closeDropdown();
            }}
          >
            Replace Resume
          </ListItem>

          <div class="destructive">
            <ListItem
              icon="fa-regular fa-trash"
              onclick={() => {
                removeCV();
                closeDropdown();
              }}
            >
              Delete Resume
            </ListItem>
          </div>
        </Dropdown>
      </div>
    {:else}
      <Button
        kind="tertiary"
        size="xsmall"
        leadingIcon="fa-regular fa-arrow-up-from-bracket"
        onclick={openUploadModal}
      >
        Upload Resume
      </Button>
    {/if}
  </div>
{/if}
